import * as React from "react"
import {Skeleton} from "@mui/material";
import {batch} from "@preact/signals-react";
import { formatDate, FORMAT_DATE_BACK } from "@ui-seeker/utils";

import {KpiTable} from "@components";
import {GROUPED_BY, PRODUCT_PAGE_ROUTES} from "@constants";
import {useShareUrl} from "@hooks";
import {commonFiltersValue, isLoadingCommonFilters} from "@signals";
import { useSkuDetailsProductPagesKpisData } from "./@hooks";
import SkuDetailsProductPageKpisActions from "./Actions";


export default function SKuDetailsProductPagesKpiTable() {
	const { buildShareParams } = useShareUrl()
	const { data, aggregation, optionSelected, handleChangeOption, isLoadingProductPageKpi } = useSkuDetailsProductPagesKpisData()

	if (isLoadingProductPageKpi) return <Skeleton variant="rectangular" height={500} />

	const links = (kpi) => [{
		icon: 'memo-circle-info',
		label: 'Go to details',
		buildUrl: (dataRow, aggregations) => `${PRODUCT_PAGE_ROUTES.DETAILS_PATH}?sp=${buildShareParams({
			...aggregations.includes(GROUPED_BY.COUNTRY) && { country: [dataRow.country] },
			...aggregations.includes(GROUPED_BY.RETAILER) && { retailer: [dataRow.siteID] },
			...aggregations.includes(GROUPED_BY.BRAND) && { brand: [dataRow.brandID] },
			...aggregations.includes(GROUPED_BY.SELLER) && {sellers: [dataRow.sellerID]}
		})}&launch=true`
	}]

	
    const columns =  [{ name: "brand_in_title_kpi", label: "Brand in \ntitle", links: links("brand_in_title_kpi") },
        { name: "brand_in_desc_kpi", label: "Brand in \nDescription", links: links("brand_in_desc_kpi") },
        { name: "long_desc_kpi", label: "Description \nlength", links: links("long_desc_kpi") },
        { name: "long_title_kpi", label: "Product Name \nlength", links: links("long_title_kpi") },
        { name: "images_kpi", label: "Images", links: links("images_kpi") },
        { name: "videos_kpi", label: "Video Presence", links: links("videos_kpi") },
        { name: "rating_kpi", label: "Rating", links: links("rating_kpi") },
        { name: "reviews_kpi", label: "Nº of \nreviews", links: links("reviews_kpi") },
        { name: "bullet_points_kpi", label: "Bullet \nPoints", links: links("bullet_points_kpi") },
        { name: "stock_kpi", label: "Stock", links: links("stock_kpi") },
        { name: "assortment_kpi", label: "Assortment", links: links("assortment_kpi") },
        { name: "recent_reviews_kpi", label: "Last review date", links: links("recent_reviews_kpi") },
        { name: "rich_content_kpi", label: "Rich \nContent", links: links("rich_content_kpi") },
        { name: "from_the_manufacturer_kpi", label: "From the \nManufacturer", links: links("from_the_manufacturer_kpi") },
        { name: "from_the_brand_kpi", label: "From the \n Brand", links: links("from_the_brand_kpi") }]
		
	return <KpiTable
		id='kpi-table'
		data={data}
		aggregations={aggregation}
		kpis={columns}
        title={'Product Pages Kpis'}
        options={{
			customToolbar: () => <SkuDetailsProductPageKpisActions optionSelected={optionSelected} handleChangeOption={handleChangeOption} />,
			enhancedSetRowProps: row => ({ sx: {
				backgroundColor: row.country === 'All' ? "primary.lighter" : 'inherit',
				...(row.country === 'All' && { "&.MuiTableRow-hover:hover": {
					backgroundColor: "primary.lighter" 
				}})
			}})
		}}
	/>
}